module.exports = __webpack_public_path__ + "static/media/air.f1fd49ec.svg";